/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import {
  Box, Button, CircularProgress, Container,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PinInput from 'react-pin-input';
import { useDispatch } from 'react-redux';
import AlertContext from '../../../../Context/AlertContext';
import Elements from '../../../Elements';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import { getUserData } from '../../../../Utils/storages';
import { setPin } from '../../../../Redux/Models/user';

export default function Component({
  classes, error, message, isLoading, isPinSet,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = getUserData();

  const [pin, setPinState] = useState();

  const { openAlert } = useContext(AlertContext);

  useEffect(() => {
    if (isPinSet) navigate(`${ROUTES.wallet()}`);
  }, [isPinSet]);

  useEffect(() => {
    if (error) {
      openAlert({
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  const handleConfirm = () => {
    dispatch(setPin(userData.id, {
      pin,
    }));
  };

  return (
    <Elements.PageBase navigate={navigate} noNav>
      <Box className={classes.root}>
        <Elements.Navigator title="Set Pin Code" />
        <Box textAlign="center" py={3}>
          <img alt="oeno bank" src={Images.Logo} />
          <Box className="s-16 weight-700" mt={3}>Set your 4 digit pin code</Box>
          <PinInput
            length={4}
            initialValue=""
            secret
            onChange={(value) => {
              setPinState(value);
            }}
            type="numeric"
            inputMode="number"
            style={{ marginTop: 24 }}
            inputStyle={{
              borderColor: '#E5E5E5',
              borderRadius: 10,
              height: 40,
              width: 40,
            }}
            inputFocusStyle={{ borderColor: '#555' }}
            onComplete={(value) => {
              setPinState(value);
            }}
            autoSelect
            regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
          />
        </Box>

        <Container className="floating-action">
          <Button fullWidth disabled={isLoading} startIcon={isLoading && (<CircularProgress size={18} sx={{ mr: 1, color: '#fff' }} />)} variant="contained" className="btn-contained" onClick={handleConfirm}>Confirm</Button>
        </Container>
      </Box>
    </Elements.PageBase>
  );
}
